const isObeActive = obeStatus => {
  switch (obeStatus) {
    case 'Frozen':
    case 'Lost':
    case 'Terminated':
    case 'Rejected':
    case 'Cancelled':
    case undefined:
      return false;
    default:
      return true;
  }
};
export default isObeActive;